import React, { useEffect, useState } from "react";
import { Button, Space, Table, Switch, Form, Input } from "antd";

import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Layout from "../../../components/Layout";

import {
  ReloadOutlined,
  SearchOutlined,
  EditOutlined,
} from "@ant-design/icons";
import MassEditModal from "../../Admin/MyQr/MassEditModal";
import { COLORS } from "../../../config/theme";
import { request } from "../../../config/API";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import authHeader from "../../../redux/services/authHeader";
import { formatDistanceToNow } from "date-fns";
import { useDebouncedCallback } from "use-debounce";
import { EDITOR_ADMIN, VIWEER_ADMIN } from "../../../config/roles";

const MyQr = () => {
  const {
    user: { role },
  } = useSelector((state) => state.auth);
  const [myQr, setMyQr] = useState([]);
  const [count, setCount] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const { primaryDark, white } = COLORS;
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  function handlePageChange(current) {
    setCurrentPage(current);
  }
  function handleSizeChange(a, b, c) {
    setCurrentPage(a);
    setPageSize(b);
  }
  const onRefresh = () => {
    setIsLoading(true);
    request
      .get(`/qr/myQr`, {
        params: { pageSize, pageNumber: currentPage },
      })
      .then(({ data: { data } }) => {
        setMyQr(data?.qr);
        setCount(data?.count);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        openNotification({
          message: "Error!",
          description: err,
          icon: "error",
        });
      });
  };

  useEffect(() => {
    onRefresh();
    //eslint-disable-next-line
  }, [dispatch, currentPage, pageSize]);

  //search
  const [searchedData, setSearchedData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchvalue, setSearchValue] = useState("");
  const [searchStatus, setSearchStatus] = useState("undecided");
  const onSearch = () => {
    if (searchvalue.length < 1) {
      return;
    }
    setIsSearching(true);
    request
      .post(
        "/user/qr/search",
        { query: searchvalue },
        { headers: { ...authHeader() } }
      )
      .then(({ data: { data } }) => {
        setSearchedData(data);
        setIsSearching(false);
        setSearchStatus("success");
      })
      .catch((e) => {
        console.log("🚀 ~ file: QRCodes.jsx ~ line 142 ~ onSearch ~ e", e);
        setIsSearching(false);
        setSearchStatus("error");
      });
  };
  useEffect(() => {
    if (searchvalue.length < 1) {
      setSearchedData([]);
      setSearchStatus("undecided");
    }
  }, [searchvalue]);
  const debounced = useDebouncedCallback(() => {
    onSearch();
  }, 500);
  useEffect(() => {
    if (!searchvalue) return;
    debounced(searchvalue);
  }, [debounced, searchvalue]);

  const columns = [
    // { title: "ID", dataIndex: "_id", key: "id" },
    {
      width: "15%",
      title: "Link",
      dataIndex: "link",
      key: "link",
      render: (text) => (
        <Link target="_blank" to={"/wc/" + text}>
          {text}
        </Link>
      ),
    },
    {
      width: "20%",
      title: "Created By",
      dataIndex: ["owner", "fullName"],
      key: "owner",
    },
    {
      width: "20%",
      title: "Name",
      dataIndex: "fName",
      key: "qrName",
      render: (row, entry) => `${row} ${entry?.lName && entry?.lName}`,
    },
    {
      width: "10%",
      title: "Total Scans",
      dataIndex: "count",
      key: "count",
    },
    {
      width: "15%",
      title: "Last Updated/Scanned",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) =>
        formatDistanceToNow(new Date(text), { addSuffix: true }),
    },

    {
      width: "20%",
      title: "Actions",
      key: "actions",
      render: (text) => {
        return (
          <Space>
            <Switch
              style={{ background: !text?.block ? "#55B659" : "#FF6461" }}
              checkedChildren={"Blocked"}
              unCheckedChildren={"Active"}
              disabled={
                role === VIWEER_ADMIN || role === EDITOR_ADMIN ? true : false
              }
              checked={text?.block}
              onChange={() => {
                request
                  .put(`qr/block/${text?._id}`, null, {
                    headers: { ...authHeader() },
                  })
                  .then(
                    ({
                      data: {
                        data: { block },
                      },
                    }) => {
                      openNotification({
                        message: "Success",
                        description: block ? "QR Blocked" : "QR Unblocked",
                        icon: "success",
                      });
                      onRefresh();
                    }
                  )
                  .catch((err) => {
                    const error =
                      err?.response?.message || err?.response?.statusText;
                    openNotification({
                      message: "Error",
                      description: error,
                      icon: "error",
                    });
                  });
              }}
            />
            <Button
              disabled={role === VIWEER_ADMIN ? true : false}
              shape="round"
              onClick={() => window.open(`edit-card/${text?.link}`, "_blank")}
            >
              Edit
            </Button>
          </Space>
        );
      },
    },
  ];

  const [showMassEditModal, setShowMassEditModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelected(selectedRows);
    },
  };

  return (
    <Layout heading="My Cards" hasBadge stat={count}>
      <Space style={{ marginBottom: 24, float: "right" }} wrap={true}>
        <Form
          onFinish={() => {
            if (searchvalue === "") {
              alert("Please enter some value!");
            } else {
              onSearch();
            }
          }}
          onFinishFailed={(x) => {
            console.log(x);
          }}
          style={{ display: "flex" }}
        >
          <Form.Item
            name="search"
            // label="Search"
            style={{ margin: 0 }}
          >
            <Input
              style={{ borderTopLeftRadius: 50, borderBottomLeftRadius: 50 }}
              allowClear
              value={searchvalue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
              placeholder="Search ..."
            />
          </Form.Item>
          <Form.Item style={{ margin: 0 }}>
            <Button
              type="primary"
              style={{
                width: 50,
                background: primaryDark,
                borderTopRightRadius: 50,
                borderBottomRightRadius: 50,
                border: "none",
                paddingLeft: 10,
                paddingRight: 10,
              }}
              htmlType="submit"
              loading={isSearching}
              icon={<SearchOutlined />}
            />
          </Form.Item>
        </Form>
        {selected?.length > 1 && (
          <Button
            type="primary"
            shape="round"
            icon={<EditOutlined />}
            style={{
              background: primaryDark,
              borderColor: primaryDark,
              color: white,
            }}
            onClick={() => setShowMassEditModal(true)}
          >
            {"Mass Edit"}
          </Button>
        )}
        <Button
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          onClick={onRefresh}
          icon={<ReloadOutlined />}
        >
          Refresh
        </Button>
      </Space>

      <Table
        size="large"
        dataSource={
          searchvalue.length > 0 && searchStatus === "success"
            ? searchedData
            : myQr
        }
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        rowKey={({ _id }) => _id}
        columns={columns}
        loading={isLoading}
        pagination={{
          hideOnSinglePage: true,
          pageSize: pageSize,
          current: currentPage,
          total: count,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          // showTotal: (total) => `Total ${total} items`,
          onChange: handlePageChange,
          showSizeChanger: true,
          onShowSizeChange: handleSizeChange,
        }}
      />
      {/* Mass Edit Modal */}
      <MassEditModal
        setShowMassEditModal={setShowMassEditModal}
        showMassEditModal={showMassEditModal}
        massData={selected}
      ></MassEditModal>
    </Layout>
  );
};

export default MyQr;
